export default __webpack_public_path__ + "static/media/Devil.b6c375af.mp4";